<template>
  <div class="od-card od-mb-6">
    <div class="od-card-body">
      <div class="od-timeline-wrap">
        <div class="od-timeline-track" />
        <div
          class="od-timeline-progress"
          :class="isCanceledFlow ? 'is-cancel' : 'is-normal'"
          :style="progressStyle"
        />
        <div
          v-for="(step, i) in activeSteps"
          :key="step.title"
          class="od-timeline-step"
        >
          <div
            class="od-step-dot"
            :class="i <= currentStepIndex ? (isCanceledFlow ? 'active-cancel' : 'active-normal') : ''"
          >
            <a-icon :type="step.icon" />
          </div>
          <span
            class="od-step-label"
            :class="i <= currentStepIndex ? (isCanceledFlow ? 'active-cancel' : 'active-normal') : ''"
          >
            {{ step.label }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderTimeline',
  props: {
    order: { type: Object, default: null },
  },
  computed: {
    stepsProcess() {
      return [
        { title: 'confirmed', code: ['WAITING_CONFIRMATION', 'SUBMITTED', 'VERIFIED'], icon: 'check-circle', label: 'Dikonfirmasi' },
        { title: 'processed', code: ['ON_PROCESS', 'ACCEPTED'], icon: 'inbox', label: 'Diproses' },
        { title: 'shipping', code: ['SHIPPED', 'DELIVERED', 'BUYER_ACCEPTED'], icon: 'car', label: 'Dikirim' },
        { title: 'completed', code: ['COMPLETED'], icon: 'star', label: 'Selesai' },
      ]
    },
    stepsCancel() {
      return [
        { title: 'cancel_requested', code: ['WAITING_CONFIRMATION', 'SUBMITTED', 'VERIFIED', 'CANCELREQUESTED'], icon: 'file-text', label: 'Req. Batal' },
        { title: 'canceled', code: ['CANCELED', 'CANCELEDPAYMENTEXPIRED', 'REJECTED'], icon: 'close-circle', label: 'Dibatalkan' },
      ]
    },
    isCanceledFlow() {
      if (!this.order) return false
      return ['CANCELED', 'CANCELREQUESTED', 'CANCELEDPAYMENTEXPIRED', 'REJECTED'].includes(this.order.order_state)
    },
    activeSteps() {
      return this.isCanceledFlow ? this.stepsCancel : this.stepsProcess
    },
    currentStepIndex() {
      if (!this.order) return -1
      let activeIndex = -1
      this.activeSteps.forEach((step, index) => {
        if (this.order.order_state === 'ACCEPTED' && step.code.includes(this.order.shipping_state)) {
          activeIndex = index
        } else if (step.code.includes(this.order.order_state)) {
          activeIndex = index
        }
      })
      return activeIndex
    },
    progressStyle() {
      if (this.currentStepIndex < 0 || this.activeSteps.length <= 1) return { width: '0%' }
      const pct = (this.currentStepIndex / (this.activeSteps.length - 1)) * 100
      return { width: `calc(${pct}% - ${(this.currentStepIndex / (this.activeSteps.length - 1)) * 5}rem)` }
    },
  },
}
</script>
